import { Alert, Button } from 'reactstrap'

export default function SuccessMessage(props) {
  console.log('SuccessMessage rendered', props)
  const { title, text, handleOk} = props

  return (
    <div style={{ padding: '20px', backgroundColor: '#F0F2F5', height: '100%' }}>
      <div style={{ height: '100%', width: '400px' }}>
        <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{title}</span>
        <Alert style={{ marginTop: '20px', maxWidth: '400px' }} color="success" data-cy="success-message">{text}</Alert>
        <Button color="secondary" style={{ float: 'right' }} onClick={handleOk}>Ok</Button>
      </div>
    </div>
  )
}
